import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './styles.css'

export default function AlertDialog(props) {
    const [open, setOpen] = React.useState(true);
    const [ticket1] = React.useState(props.ticket);
    const [token1] = React.useState(props.token);

    
    const handleClose = () => {
        props.callbackParent()
        setOpen(false);
    };
    
  
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Chamado aberto. Guarde o número:"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className='ticket-container'>
            {/* (04/09) era um link para o histórico da Octadesk — o chamado não
                nasce mais lá. O número é o do NOSSO motor; a equipe responde
                pelo e-mail informado. */}
            <span className='ticket'>{ticket1}</span>
            </DialogContentText>
            <DialogContentText>
              {"Você recebe as atualizações por e-mail."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Fechar</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  